export default {
    lang: 'ua',
    title: 'Veterans Up | dentsu Ukraine',
    description: "Кар'єрний проєкт для військових, ветеранів та їхніх сімей у рекламній індустрії від найбільшої комунікаційної групи в Україні. Передбачає навчальний курс за низкою спеціальностей, менторство, профорієнтацію. ",
    keywords: 'навчання для ветеранів, профорієнтація, кар\'єра, рекламна індустрія, навчання PPC, навчання SEO, освіта для військових',
}